import React, { useState, useEffect } from 'react';
import { intialLoading, setIndex } from '../../store/screentransistion/actions';
import { saveUserDetails } from '../../store/trackinguser/actions';
import Layout from '../common/layoutred';
import Buttonn from '../../assets/images/backgrounds/submit_button.png';
import { fetchShuffle } from '../../store/shuffledata/operations';
import { Alert } from '@material-ui/lab';
import { isAndroid } from 'react-device-detect';
import './style.scss';
import fullScreen from '../../utils/fullScreen';
import { connect } from 'react-redux';
import {
  toggleMusic,
  toggleVoiceOver,
} from '../../store/screentransistion/actions';
import music from '../../assets/audio/BGMusic.mp3';
import PlayMusic from '../../utils/playMusic';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { termsEn, termsHi, termsKn, termsMr, termsTa } from './terms';
window.gtag('event', 'REGISTRATION', {
  'event_category': 'REGISTRATION',
  'event_label': 'REGISTRATION'
});


const Registration = ({
  fetchShuffle,
  shuffleData,
  progress,
  languages,
  zones,
  saveUserDetails,
  audio,
  intialLoading,
  setIndex,
  gameSessionId,
  language,
  toggleMusic,
  toggleVoiceOver,
  userSelectedLanguage,
  trackingUser,
}) => {
  const [india] = zones;
  // const [english] = languages;

  const [data, setData] = useState({
    zone: india._id,
    lang: userSelectedLanguage,
    number: '',
  });

  const [selectedLanguage, setSelectedLanguage] = useState(userSelectedLanguage)
  //terms
  const [isChecked, setIsChecked] = useState(false)
  const [hide, setHide] = useState(false)

  const handleCheckbox = (event) => {
    setIsChecked(!isChecked)
    if (event.target.checked) {
      setError(false)
      setMsg("")
    }
  }
  const toggleCheckbox = () => {
    if (!isChecked) {
      setError(false)
      setMsg("")
    }
    setIsChecked(!isChecked)
  }

  const activate = fullScreen();

  const [error, setError] = useState(false);
  const [msg, setMsg] = useState('Please enter valid details');

  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState('paper');
  //warining localizing
  const [text3, setText3] = useState("")
  useEffect(() => {
    if (selectedLanguage === "en") {
      setText3("Maximum 10 numbers allowed")
    }
    if (selectedLanguage === "hi") {
      setText3("अधिकतम 10 नंबरों की अनुमति है")
    }
    if (selectedLanguage === "kn") {
      setText3("ಗರಿಷ್ಠ 10 ಸಂಖ್ಯೆಗಳನ್ನು ಅನುಮತಿಸಲಾಗಿದೆ")
    }
    if (selectedLanguage === "mr") {
      setText3("जास्तीत जास्त 10 नंबरांना परवानगी आहे")
    }
  }, [selectedLanguage])
  const [text4, setText4] = useState("")
  useEffect(() => {
    if (selectedLanguage === "en") {
      setText4("Please enter a number")
    }
    if (selectedLanguage === "hi") {
      setText4("एक संख्या दर्ज करें")
    }
    if (selectedLanguage === "kn") {
      setText4("ದಯವಿಟ್ಟು ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ")
    }
    if (selectedLanguage === "mr") {
      setText4("कृपया एक नंबर प्रविष्ट करा")
    }
  }, [selectedLanguage])
  const handleClickOpen = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === 'number') {
      const onlyDigits = String(value).replace(/\D/g, '');
      const trimmed = onlyDigits.slice(0, 10);
      setData({ ...data, number: trimmed });
      setError(false);
      return;
    }
    setData({ ...data, [name]: value });
  };
  // const handleChange = (event) => {
  //   const { name, value } = event.target;
  //   setData({ ...data, [name]: value });
  // };

  // useEffect(() => {
  //   const path = window.location.pathname;
  //   const number = path.replace('/', '');
  //   setData({ ...data, number: number });
  // }, []);

  // const register = (event) => {
  //   event.preventDefault();
  //   if (
  //     data.number === '' ||
  //     data.number === undefined ||
  //     data.number === null ||
  //     data.number === '/_' ||
  //     data.number === '/' ||
  //     data.number === `/''` ||
  //     data.number === `/'%20'`
  //   ) {
  //     setError(true);
  //     setMsg('Invalid Token');
  //     return;
  //   }
  //   if (data.lang && data.zone && data.number) {
  //     fetchShuffle(
  //       [data.lang, data.number],
  //       () => {
  //         // This is done so that audio controls are initiated as part of a user action
  //         toggleVoiceOver(true);
  //         toggleMusic(true);
  //         const audioRef = PlayMusic(music);
  //         audioRef.pause();

  //         intialLoading();
  //         setIndex(0);
  //         saveUserDetails(data);
  //         if (isAndroid) {
  //           activate();
  //         }
  //       },
  //       (err) => {
  //         setError(true);
  //         setMsg('NetWork Failed Please Check Network Connection');
  //       }
  //     );
  //   } else {
  //     setError(true);
  //     setMsg('Invalid Token');
  //   }
  // };

  //terms and conditions
  // REMOVE THE HARDCODED terms and terms2 constants
  
  //terms and condition localized
  const [conditions, setConditions] = useState("")
  useEffect(() => {
    if (selectedLanguage === "en") {
      setConditions(termsEn)
    }
    if (selectedLanguage === "hi") {
      setConditions(termsHi)
    }
    if (selectedLanguage === "kn") {
      setConditions(termsKn)
    }
    if (selectedLanguage === "mr") {
      setConditions(termsMr)
    }
    if (selectedLanguage === "ta") {
      setConditions(termsTa)
    }
  }, [selectedLanguage]) // Add selectedLanguage to dependency array

  //Registration page terms and condition text localizing
  const [text1, setText1] = useState("")
  useEffect(() => {
    if (selectedLanguage === "en") {
      setText1("agree with")
    }
    if (selectedLanguage === "hi") {
      setText1("से सहमत")
    }
    if (selectedLanguage === "kn") {
      setText1("ಸಮ್ಮತಿಸಿ")
    }
    if (selectedLanguage === "mr") {
      setText1("सह सहमत")
    }
    if (selectedLanguage === "ta") {
      setText1("முறையும் மறுபுறமும் மாற்றியமைக்கப்பட்டுள்ளது")
    }
  }, [selectedLanguage])

  const [text2, setText2] = useState("")
  useEffect(() => {
    if (selectedLanguage === "en") {
      setText2("Terms and Conditions")
    }
    if (selectedLanguage === "hi") {
      setText2("नियम और शर्तें")
    }
    if (selectedLanguage === "kn") {
      setText2("ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು")
    }
    if (selectedLanguage === "mr") {
      setText2("नियम आणि अटी")
    }
    if (selectedLanguage === "ta") {
      setText2("நியமங்கள் மற்றும் நிபந்தனைகள்")
    }
  }, [selectedLanguage])

  const [placeHolder, setPlaceHolder] = useState("")
  useEffect(() => {
    if (selectedLanguage === "en") {
      setPlaceHolder("Enter phone number")
    }
    if (selectedLanguage === "hi") {
      setPlaceHolder("फ़ोन नंबर दर्ज करें")
    }
    if (selectedLanguage === "kn") {
      setPlaceHolder("ಫೋನ್ ನಂಬರ್ ನಮೂದಿಸಿ")
    }
    if (selectedLanguage === "mr") {
      setPlaceHolder("फोन नंबर प्रविष्ट करा")
    }
    if (selectedLanguage === "ta") {
      setPlaceHolder("தொலைபேசி எண்ணை உள்ளிடுக")
    }
  }, [selectedLanguage])

  //start button
  const [start, setStart] = useState("")
  useEffect(() => {
    if (selectedLanguage === "en") {
      setStart("Start")
    }
    if (selectedLanguage === "hi") {
      setStart("प्रारंभ")
    }
    if (selectedLanguage === "kn") {
      setStart("ಪ್ರಾರಂಭಿಸಿ")
    }
    if (selectedLanguage === "mr") {
      setStart("सुरू करा")
    }
    if (selectedLanguage === "ta") {
      setStart("தொடங்குக")
    }
  }, [selectedLanguage])

  //alert terms and conditions
  const [alertTc, setAlertTc] = useState("")
  useEffect(() => {
    if (selectedLanguage === "en") {
      setAlertTc("Please agree terms and conditions")
    }
    if (selectedLanguage === "hi") {
      setAlertTc("कृपया नियम और शर्तों से सहमत हों")
    }
    if (selectedLanguage === "kn") {
      setAlertTc("ದಯವಿಟ್ಟು ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳನ್ನು ಒಪ್ಪಿಕೊಳ್ಳಿ")
    }
    if (selectedLanguage === "mr") {
      setAlertTc("कृपया नियम आणि अटींशी सहमत व्हा")
    }
    if (selectedLanguage === "ta") {
      setAlertTc("நிபந்தனைகளுடன் सहमत வேண்டும்")
    }
  }, [selectedLanguage])
  //Alert valid mobile number
  // const[alertMobileno,setAlertMobileno]=useState("")
  // useEffect(()=>{
  //   if(selectedLanguage==="en"){
  //     setAlertMobileno("Please enter valid number")
  //   }
  //   if(selectedLanguage==="hi"){
  //     setAlertMobileno("कृपया मान्य संख्या दर्ज करें")
  // }
  // },[])
  //terms and condition close
  const [close, setClose] = useState("")
  useEffect(() => {
    if (selectedLanguage === "en") {
      setClose("Close")
    }
    if (selectedLanguage === "hi") {
      setClose("बंद करना")
    }
    if (selectedLanguage === "kn") {
      setClose("ಮುಚ್ಚಿರಿ")
    }
    if (selectedLanguage === "mr") {
      setClose("बंद करा")
    }
    if (selectedLanguage === "ta") {
      setClose("முடிவு")
    }
  }, [selectedLanguage])
  const [tcTitle, setTcTitle] = useState("")
  useEffect(() => {
    if (selectedLanguage === "en") {
      setTcTitle("FINANCIAL JOURNEY CONDITIONS AND TERMS")
    }
    if (selectedLanguage === "hi") {
      setTcTitle("वित्तीय यात्रा की शर्तें और शर्तें")
    }
    if (selectedLanguage === "kn") {
      setTcTitle("ಹಣಕಾಸು ಪಯಣದ ಷರತ್ತುಗಳು ಮತ್ತು ನಿಯಮಗಳು")
    }
    if (selectedLanguage === "mr") {
      setTcTitle("आर्थिक प्रवासाच्या अटी आणि नियम")
    }
    if (selectedLanguage === "ta") {
      setTcTitle("மதிப்பு பயணத்தின் நிபந்தனைகள் மற்றும் நிபந்தனைகள்")
    }
  }, [selectedLanguage])
  // const register = (event) => {
  //   event.preventDefault();
  //   console.log(data.number.length)

  //   const pattern=/^[6-9]{1}[0-9]{9}$/
  //   console.log("here",pattern.test(data.number))
  //   if (!pattern.test(data.number)) {
  //     setError(!pattern.test(data.number));
  //     setMsg(alertMobileno);
  //     return;
  //   }
  //   if(!isChecked){
  //     setError(true);
  //     setMsg(alertTc);
  //     return;
  //   }
  //   if (data.number.length === 10 && data.lang && data.zone) {  
  //     fetchShuffle(
  //       [data.lang, data.number],       
  //       () => {
  //         // This is done so that audio controls are initiated as part of a user action
  //         toggleVoiceOver(true);
  //         toggleMusic(true);
  //         const audioRef = PlayMusic(music);
  //         audioRef.pause();

  //         intialLoading();
  //         setIndex(0);
  //         saveUserDetails(data);
  //         if (isAndroid) {
  //           activate();
  //         }
  //       },
  //       (err) => {
  //         setError(true);
  //         setMsg('NetWork Failed Please Check Network Connection');
  //       }
  //     );
  //   } else {
  //     setError(true);
  //     setMsg('All fields are required');
  //   }
  // };

  useEffect(() => {
    if (trackingUser && trackingUser.user) {
      const mobileNumber = trackingUser.user.number || '';
      setData((prev) => ({ ...prev, number: mobileNumber }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trackingUser]);
  const register = (event) => {
    event.preventDefault();
    if (
      data.number === '' ||
      data.number === undefined ||
      data.number === null ||
      data.number === '/_' ||
      data.number === '/' ||
      data.number === `/'/'` ||
      data.number === `/'%20/'`
    ) {
      setError(true);
      setMsg('Invalid Token');
      return;
    }
    if (!isChecked) {
      setError(true);
      setMsg(alertTc);
      return;
    }
    if (data.lang && data.zone && data.number) {
      // resetShuffleData();
      // resetUserState()
      fetchShuffle(
        [data.lang, data.number],
        () => {
          // This is done so that audio controls are initiated as part of a user action
          toggleVoiceOver(true);
          toggleMusic(true);
          const audioRef = PlayMusic(music);
          audioRef.pause();

          intialLoading();
          setIndex(0);
          saveUserDetails(data);
          if (isAndroid) {
            activate();
          }
        },
        (err) => {
          setError(true);
          setMsg('NetWork Failed Please Check Network Connection');
        }
      );
    } else {
      setError(true);
      setMsg('Invalid Token');
    }
  };
  return (
    <>
      <Layout>
        <div className="registration__container">
          <form className="registration__form" onSubmit={register}>

            {/* <div className="form__control">
              <select
                name="country"
                value={data.country}
                onChange={handleChange}
              >
                {zones
                  ? zones.map((zone) => (
                      <option key={zone._id} value={zone._id}>
                        {zone.zoneName}
                      </option>
                    ))
                  : null}
              </select>
            </div> */}
           
            <div className="terms__condition">
              <div> <input type="checkbox" checked={isChecked} onChange={handleCheckbox} style={{ verticalAlign: 'middle', transform: "scale(1.7)" }} />
                <Button style={{ marginTop: '1px' }}>
                  <div className="termstext" >
                    <h2 style={{ color: 'white' }}><span onClick={toggleCheckbox}>{text1} </span><span onClick={handleClickOpen('paper')} style={{ color: 'black', textDecoration: "underline" }}>{text2}</span></h2>
                  </div>
                </Button>
                <Dialog
                  open={open}
                  onClose={handleClose}
                  scroll={scroll}
                  aria-labelledby="scroll-dialog-title"
                  aria-describedby="scroll-dialog-description"
                >
                  <DialogTitle id="scroll-dialog-title">
                    {tcTitle}
                  </DialogTitle>
                  <DialogContent dividers={scroll === 'paper'}>
                    <DialogContentText
                      id="scroll-dialog-description"
                      ref={descriptionElementRef}
                      tabIndex={-1}
                    >
                      {conditions}
                      {/* {[...new Array(1)]
                      .map(
                        () => ``
                      )
                      .join('\n')} */}
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleClose}>
                      <h2>{close}</h2>
                    </Button>
                    {/* <Button onClick={handleClose}>Subscribe</Button> */}
                  </DialogActions>
                </Dialog>
              </div>
            </div>
            <div
              type="submit"
              className="form__control start_button"
              onClick={register}
            >
              <img src={Buttonn} alt="start_image" />
              <div type="submit" className="button__text">
                {start}
              </div>
            </div>
            <div className="form__control error__msg">
              {error ? (
                <Alert severity="error">
                  <h3>{msg}</h3>
                </Alert>
              ) : null}
            </div>
          </form>
        </div>
      </Layout>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    shuffleData: state.shuffleData,
    progress: state.progress,
    languages: state.intialize.languages,
    zones: state.intialize.zones,
    audio: state.shuffleData,
    language: state.trackingUser.userDeatils,
    userSelectedLanguage: state.trackingUser.lang,
    trackingUser: state.trackingUser
  };
};

const mapDispathToProps = (dispatch) => {
  return {
    fetchShuffle: (language, success, failure) =>
      dispatch(fetchShuffle(language, success, failure)),
    saveUserDetails: (details) => dispatch(saveUserDetails(details)),
    intialLoading: () => dispatch(intialLoading()),
    setIndex: (index) => dispatch(setIndex(index)),
    toggleMusic: (toggle) => dispatch(toggleMusic(toggle)),
    toggleVoiceOver: (toggle) => dispatch(toggleVoiceOver(toggle)),

  };
};

export default connect(mapStateToProps, mapDispathToProps)(Registration);
